export enum VideoProvider {
  BRIGHTCOVE = 'brightcove',
  JWPLAYER = 'jwplayer',
  DAILYMOTION = 'dailymotion',
  FCPLAYER = 'fcplayer',
  PIXELS_SHORTS_PLAYER = 'pixels_shorts_player',
}

export enum PixelsVideoEvent {
  AD_IMPRESSION = 'adImpression',
  AD_TIME = 'adTime',
  AD_1ST_QUARTILE = 'ad_1st_quartile',
  AD_MID_POINT = 'ad_mid_point',
  AD_3RD_QUARTILE = 'ad_3rd_quartile',
  AD_STARTED = 'adStarted',
  AD_ENDED = 'adEnded',
  AD_ERROR = 'adError',
  AD_CLICK = 'adClick',
  AD_REQUEST = 'adRequest',
  AD_SKIPPED = 'adSkipped',
  INIT = 'init',
  VIDEO_ENDED = 'videoEnded',
  FIRST_FRAME = 'firstFrame',
  VIDEO_CONTEXTUAL = 'contextual',
  TIME = 'time',
  MUTE = 'mute',
  BEFORE_COMPLETE = 'beforeComplete',
  VIDEO_CHANGE = 'videoChange',
  BEACON_SENT = 'beaconSent',
  VIDEO_BEFORE_PLAY = 'beforePlay',
  CLUSTER_START = 'clusterStart'
}

export const AdEventChange = [
  PixelsVideoEvent.AD_TIME,
  PixelsVideoEvent.AD_1ST_QUARTILE,
  PixelsVideoEvent.AD_MID_POINT,
  PixelsVideoEvent.AD_3RD_QUARTILE,
  PixelsVideoEvent.AD_ENDED,
  PixelsVideoEvent.AD_STARTED,
];

// the key on the left is the pixel event, on the right is the player event
export const jwPlayerEventMap = new Map(Object.entries({
  [PixelsVideoEvent.AD_IMPRESSION]: 'adImpression',
  [PixelsVideoEvent.AD_STARTED]: 'adStarted',
  [PixelsVideoEvent.AD_ENDED]: 'adComplete',
  [PixelsVideoEvent.AD_TIME]: 'adTime',
  [PixelsVideoEvent.AD_ERROR]: 'adError',
  [PixelsVideoEvent.AD_REQUEST]: 'adRequest',
  [PixelsVideoEvent.AD_SKIPPED]: 'adSkipped',
  [PixelsVideoEvent.AD_CLICK]: 'adClick',
  [PixelsVideoEvent.FIRST_FRAME]: 'firstFrame',
  [PixelsVideoEvent.TIME]: 'time',
  [PixelsVideoEvent.BEFORE_COMPLETE]: 'beforeComplete',
  [PixelsVideoEvent.VIDEO_CHANGE]: 'nextClick',
  [PixelsVideoEvent.VIDEO_BEFORE_PLAY]: 'playlist',
}));

export const dailyMotionPlayerEventMap = new Map(Object.entries({
  [PixelsVideoEvent.AD_IMPRESSION]: 'ad_impression',
  [PixelsVideoEvent.AD_STARTED]: 'ad_start',
  [PixelsVideoEvent.AD_ENDED]: 'ad_end',
  [PixelsVideoEvent.AD_TIME]: 'ad_timeupdate',
  [PixelsVideoEvent.AD_ERROR]: 'ad_error',
  [PixelsVideoEvent.AD_REQUEST]: 'ad_readytofetch',
  // player adaptor will forward this event when ad
  [PixelsVideoEvent.AD_SKIPPED]: 'ad_skipped',
  [PixelsVideoEvent.AD_CLICK]: 'ad_click',
  [PixelsVideoEvent.FIRST_FRAME]: 'video_start',
  [PixelsVideoEvent.TIME]: 'timeupdate',
  [PixelsVideoEvent.BEFORE_COMPLETE]: 'video_end',
  [PixelsVideoEvent.VIDEO_CHANGE]: 'videochange',
  [PixelsVideoEvent.VIDEO_BEFORE_PLAY]: 'videochange'
}));

export const fcPlayerEventMap = new Map(Object.entries({
  [PixelsVideoEvent.AD_IMPRESSION]: 'viewable_impression',
  [PixelsVideoEvent.AD_STARTED]: 'ads-ad-started',
  [PixelsVideoEvent.AD_REQUEST]: 'ads-request',
  [PixelsVideoEvent.AD_ENDED]: 'ads-ad-ended',
  [PixelsVideoEvent.AD_1ST_QUARTILE]: 'ads-first-quartile',
  [PixelsVideoEvent.AD_MID_POINT]: 'ads-midpoint',
  [PixelsVideoEvent.AD_3RD_QUARTILE]: 'ads-third-quartile',
  [PixelsVideoEvent.AD_TIME]: 'adProgress',
  [PixelsVideoEvent.AD_CLICK]: 'ads-click',
  [PixelsVideoEvent.AD_SKIPPED]: 'adskip',
  [PixelsVideoEvent.FIRST_FRAME]: 'custom-firstframe',
  [PixelsVideoEvent.TIME]: 'timeupdate',
  [PixelsVideoEvent.MUTE]: 'volumechange',
  [PixelsVideoEvent.BEFORE_COMPLETE]: 'contentended',
  [PixelsVideoEvent.VIDEO_BEFORE_PLAY]: 'loadedmetadata'
  // [PixelsVideoEvent.VIDEO_CHANGE]: 'contentended'
}));

export const pixelsShortPlayerEventMap = new Map(Object.entries({
  [PixelsVideoEvent.AD_IMPRESSION]: 'impression',
  [PixelsVideoEvent.AD_STARTED]: 'ads-ad-started',
  [PixelsVideoEvent.AD_REQUEST]: 'ads-request',
  [PixelsVideoEvent.AD_ENDED]: 'pixels-ads-ended',
  // [PixelsVideoEvent.AD_1ST_QUARTILE]: 'pixels-ads-first-quartile',
  // [PixelsVideoEvent.AD_MID_POINT]: 'pixels-ads-midpoint',
  // [PixelsVideoEvent.AD_3RD_QUARTILE]: 'pixels-ads-third-quartile',
  [PixelsVideoEvent.AD_TIME]: 'pixels-ads-progress',
  [PixelsVideoEvent.AD_CLICK]: 'pixels-ads-click',
  [PixelsVideoEvent.AD_SKIPPED]: 'pixels-ads-skipped',
  [PixelsVideoEvent.FIRST_FRAME]: 'custom-firstframe',
  [PixelsVideoEvent.TIME]: 'timeupdate',
  [PixelsVideoEvent.MUTE]: 'volumechange',
  [PixelsVideoEvent.BEFORE_COMPLETE]: 'ended',
  [PixelsVideoEvent.VIDEO_BEFORE_PLAY]: 'loadedmetadata',
  [PixelsVideoEvent.VIDEO_CHANGE]: 'pixels-video-change',
  [PixelsVideoEvent.CLUSTER_START]: 'pixels-video-cluster-start'
}));
